import React from "react";
import { Box, Paper, Grid, Typography } from "@material-ui/core";

import { VictoryPie, VictoryLabel, VictoryContainer } from "victory";

const CardDashboardRelatorio = (props) => {
    const pieWidth = 250;

    const total = props.dados.total_consultas_mes;

    const dados =
        total > 0
            ? [{ y: props.dados.positivo }, { y: props.dados.negativo }]
            : [{ y: 100 }];

    const cores = total > 0 ? ["#6CA76B", "#F44336"] : ["#999"];

    return (
        <Paper>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Grid item md={6} xs={12}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Box height="19rem" width="100%">
                            <VictoryPie
                                data={dados}
                                innerRadius={60}
                                colorScale={cores}
                                width={pieWidth}
                                height={pieWidth}
                                padAngle={0}
                                labels={() => null}
                                labelComponent={
                                    <VictoryLabel
                                        textAnchor="middle"
                                        verticalAnchor="middle"
                                        style={[
                                            {
                                                fontWeight: "400",
                                                fontSize: 14,
                                                fontFamily:
                                                    "Roboto, sans-serif",
                                                fill: "#17325C",
                                            },
                                            {
                                                fontWeight: "400",
                                                fontSize: 14,
                                                fontFamily:
                                                    "Roboto, sans-serif",
                                                fill: "#17325C",
                                            },
                                        ]}
                                        x={pieWidth * 0.5}
                                        y={pieWidth * 0.5}
                                        text={["Suas", "Pesquisas"]}
                                    />
                                }
                                containerComponent={
                                    <VictoryContainer
                                        responsive={true}
                                        width={pieWidth}
                                        height={pieWidth}
                                    />
                                }
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Box
                        padding="2rem"
                        alignItems="center"
                        justifyContent="center"
                        display="flex"
                    >
                        <Box maxWidth="60vw">
                            <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography color="primary">
                                                {props.dados.negativo}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography color="primary">
                                                <b>Negativas</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Box
                                                height="0.25rem"
                                                width="96%"
                                                borderRadius={20}
                                                bgcolor="#F44336"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography color="primary">
                                                {props.dados.positivo}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Typography color="primary">
                                                <b>Positivas</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Box
                                                height="0.25rem"
                                                width="96%"
                                                borderRadius={20}
                                                bgcolor="#6CA76B"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography color="primary">
                                                {props.dados.em_processamento}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography color="primary">
                                                <b>Em andamento</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Box
                                                height="0.25rem"
                                                width="96%"
                                                borderRadius={20}
                                                bgcolor="#2196F3"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography color="primary">
                                                {
                                                    props.dados
                                                        .total_consultas_mes
                                                }
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography color="primary">
                                                <b>Total de pesquisas</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={10}>
                                            <Box
                                                height="0.25rem"
                                                width="100%"
                                                borderRadius={20}
                                                bgcolor="#00000061"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default CardDashboardRelatorio;
